import React, { forwardRef, useState, useEffect } from 'react';
import DatePickerReact, { ReactDatePickerProps } from 'react-datepicker';
import { CalendarBlank } from 'phosphor-react';
import { ptBR } from 'date-fns/locale';

import 'react-datepicker/dist/react-datepicker.css';

import { DatePickerContainer, DatePickerStyle } from './styles';

type ButtonProps = React.HTMLProps<HTMLButtonElement>;
export type DateRangeWithTimePickerProps = ReactDatePickerProps;

interface DateRangeState {
  startDate: Date;
  endDate: Date;
}

interface ButtonPropsI extends ReactDatePickerProps {
  setDateRange?: (payload: DateRangeState) => void;
  disabled?: boolean;
  defaultStartDate?: Date;
  defaultEndDate?: Date;
  shouldCloseOnSelect?: boolean;
}

export const DateRangeWithTimePicker: React.FC<ButtonPropsI> = ({
  setDateRange = () => {},
  disabled = false,
  defaultStartDate,
  defaultEndDate,
  shouldCloseOnSelect = false,
  ...props
}) => {
  const [start, setStart] = useState<Date | null>(
    defaultStartDate ? defaultStartDate : new Date(),
  );
  const [end, setEnd] = useState<Date | null>(
    defaultEndDate ? defaultEndDate : new Date(),
  );

  const dateType = (dates: [Date | null, Date | null]) => {
    const [selectedStart, selectedEnd] = dates;

    setStart(selectedStart);
    setEnd(selectedEnd);
    dateType(dates);
  };

  useEffect(() => {
    if (end && start) {
      setDateRange({ startDate: start, endDate: end });
    }
  }, [end, start, setDateRange]);

  const DatePickerCustomInput = forwardRef<HTMLButtonElement, ButtonProps>(
    ({ value, onClick }) => {
      return (
        <DatePickerContainer
          className="datepicker-custom-input"
          onClick={onClick}
          type="button"
          disabled={disabled}
        >
          <span className={`${value === '' && 'color-gray-70'}`}>
            {value === '' ? 'dd/mm/aaaa hh:mm' : value}
          </span>
          <div className="calendar">
            <CalendarBlank />
          </div>
        </DatePickerContainer>
      );
    },
  );

  const DatePickerCustomInputWithoutIcon = forwardRef<
    HTMLButtonElement,
    ButtonProps
  >(({ value, onClick }) => {
    return (
      <DatePickerContainer
        className="datepicker-custom-input"
        onClick={onClick}
        type="button"
        disabled={disabled}
      >
        <span className={`${value === '' && 'color-gray-70'}`}>
          {value === '' ? 'dd/mm/aaaa hh:mm' : value}
        </span>
      </DatePickerContainer>
    );
  });

  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(new Date());

  return (
    <div
      className="border"
      style={{ border: '1px solid #dae0e7', borderRadius: '4px' }}
    >
      <DatePickerStyle>
        <DatePickerReact
          selected={startDate}
          customInput={<DatePickerCustomInputWithoutIcon />}
          selectsStart
          startDate={startDate}
          showTimeInput
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          timeInputLabel="Horário: "
          dateFormat="dd/MM/yyyy HH:mm"
          locale={ptBR}
          {...props}
          onChange={(date) => setStartDate(date)}
          shouldCloseOnSelect={false}
        />
        <DatePickerReact
          selected={endDate}
          customInput={<DatePickerCustomInput />}
          selectsEnd
          endDate={endDate}
          minDate={startDate}
          showTimeInput
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          timeInputLabel="Horário: "
          dateFormat="dd/MM/yyyy HH:mm"
          locale={ptBR}
          {...props}
          onChange={(date) => setEndDate(date)}
          shouldCloseOnSelect={false}
        />
      </DatePickerStyle>
    </div>
  );
};
